import { makeStyles } from "@material-ui/core";

export default makeStyles(
  theme => ({
    actions: {
      borderTop: "none",
      display: "flex",
      justifyContent: "center",
      marginBottom: 14
    },
    cancelButton: {
      "& .MuiButton-label": {
        color: "#002972",
        fontSize: "0.875rem",
        fontWeight: 600
      },
      backgroundColor: "#F4F4F4",
      borderRadius: 6,
      height: 39,
      padding: "6px 30px",
      width: 136
    },
    closeIcon: {
      margin: 10,
      padding: 5,
      position: "absolute",
      right: 0,
      top: 0
    },
    content: {
      [theme.breakpoints.down("sm")]: {
        padding: "0 2em"
      },
      padding: "0 6em",
      textAlign: "center"
    },
    contentEmail: {
      fontWeight: "bold",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    dialog: {
      borderRadius: 10,
      position: "relative",
      right: 0,
      top: 0
    },
    title: {
      border: "none",
      fontWeight: "bold"
    },
    titleText: {
      color: "#EC5D77",
      fontSize: "1em",
      fontWeight: 800,
      marginTop: 20,
      textAlign: "center"
    },
    titleWrapper: {
      position: "relative"
    },
    yesButton: {
      "& .MuiButton-label": {
        color: "#FFFFFF",
        fontSize: "0.875rem",
        fontWeight: 600,
        padding: 2
      },
      "&:hover": {
        backgroundColor: "#ACCAFF"
      },
      "&:hover .MuiButton-label": {
        color: "#0030FF"
      },
      backgroundColor: "#0030FF",
      borderRadius: 6,
      height: 39,
      padding: "6px 30px",
      width: 136
    }
  }),
  {
    name: "RemoveAccountDialog"
  }
);
